import controller from './wf-affect-list-content.controller';
import template from './wf-affect-list-content.html';
import './wf-affect-list-content.scss';

export default {
	controller,
	template,
	bindings: {
		affectList:      '<?',
		data:            '<?ngModel',
		disabled:        '<ngDisabled',
		form:            '<?form',
		modelActions:    '=',
		options:         '<',
		selected:        '=?',
		showAddWorkflow: '=?',
	},
	require:  {
		kform:        '^^?kform',
		wfAffectList: '^^?',
	},
};
